module.exports = __webpack_public_path__ + "static/media/contactInfo.72d9d065.png";